window.addEventListener('DOMContentLoaded', () =>
  {
    const ratingBlock = document.querySelector('.rating-block__polls');
    const ratingResult = document.querySelector('.rating-block__result');
    const likeBtn = document.querySelector('.rating-block__like');
    const dislikeBtn = document.querySelector('.rating-block__dislike');

    const handleClick = () => {
      ratingBlock.style.display = 'none';
      ratingResult.style.display = 'flex';
    };
  
    likeBtn?.addEventListener('click', handleClick);
    dislikeBtn?.addEventListener('click', handleClick);
  })